// Dashboard-only display relabeling + gating for pipeline stages.
//
// IMPORTANT: the backend stage `label` (which the dashboard sees as `item.name`)
// stays the logic key — percentages and keyword matching ("intro call",
// "closed", "- 0%", ...) are derived from it all over Dashboard.js. We do NOT
// change that. These helpers only affect what the UI *shows* and which columns
// are rendered, so the rename/hide are cheap gates with no DB migration.

// Order matters only for readability; the match strings are mutually exclusive.

// **Important**: match as-set from the 9 canonical local stages
// (sync_pipeline_stages.py / LOCAL_STAGES).
const STAGE_DISPLAY_NAME_MAP = [
  { match: 'outreach - 0', label: 'Data Points' },
  { match: 'future-outreach - 5', label: 'Future Outreach' },
  { match: 'qualified meetings', label: 'Qualified Meetings' },
  { match: 'intro call', label: '10%(NDA/warm Leads)' },
  { match: 'workshop + dm', label: '25%(Requirement Mapping, Demo given)' },
  { match: 'nb loi + msa', label: '50%(Proposal)' },
  { match: 'dd - phase', label: '75%-90%(Negotiation)' },
  { match: 'closing', label: '75%-90%(Negotiation)' }, // 90% column is hidden (isHiddenStage); merged into Negotiation
  { match: 'closed', label: '100% Closer' }, // "Closed (Nurturing/risk) - 100%" contains "closed"
];

/**
 * Map a raw DB stage label to its dashboard display name.
 * Falls back to the raw name for anything unmapped (e.g. "Qualified Meetings"
 * and any future stage), so new stages just show their own label.
 */
export const getStageDisplayName = (name) => {
  if (!name) return name;
  const lower = name.toLowerCase();
  for (const { match, label } of STAGE_DISPLAY_NAME_MAP) {
    if (lower.includes(match)) return label;
  }
  return name;
};

/**
 * The 90% "Closing" stage is hidden from the board (cheap gate — the stage still
 * exists in the DB, it's just not rendered as a column).
 */
export const isHiddenStage = (name) =>
  !!name && name.toLowerCase().includes('90%');
